export const BUILDERS = [
  {
    id: "rapidnative",
    name: "RapidNative",
    cta: "Build with RapidNative",
    url: "https://www.rapidnative.com",
    recommended: true,
    tagline: "Turn prompts into real iPhone & Android apps (React Native / Expo).",
    bestFor: "Native Mobile Apps",
    stack: "React Native + Expo",
    instructions:
      "Paste this blueprint into RapidNative to generate production-ready React Native screens for iOS and Android. Start from the Required Screens, then wire up data and auth.",
  },
  {
    id: "lovable",
    name: "Lovable",
    cta: "Build with Lovable",
    url: "https://lovable.dev",
    tagline: "Beautiful interfaces and rapid MVP development.",
    bestFor: "Beautiful User Interfaces",
    stack: "React + Tailwind + Supabase",
    instructions:
      "Paste this blueprint into Lovable and focus on the Required Screens first. Refine the UI iteratively, then connect data and auth.",
  },
  {
    id: "bolt",
    name: "Bolt.new",
    cta: "Build with Bolt",
    url: "https://bolt.new",
    tagline: "Fast AI application builder.",
    bestFor: "Rapid MVP Development",
    stack: "React + Vite + Node",
    instructions:
      "Paste this blueprint into Bolt.new to spin up a working MVP fast. Start from the Core Features and expand.",
  },
  {
    id: "replit",
    name: "Replit",
    cta: "Build with Replit",
    url: "https://replit.com",
    tagline: "Full-stack coding and deployment.",
    bestFor: "Full Stack Development",
    stack: "Your choice (Python/Node) + DB",
    instructions:
      "Use Replit Agent with this blueprint to build and deploy a full-stack app. Follow the Database and Authentication sections closely.",
  },
  {
    id: "firebase",
    name: "Firebase Studio",
    cta: "Build with Firebase Studio",
    url: "https://firebase.studio",
    tagline: "Authentication, backend and scalable applications.",
    bestFor: "Backend & Authentication",
    stack: "Firebase Auth + Firestore + Hosting",
    instructions:
      "Paste this blueprint into Firebase Studio. Prioritize the Authentication Flow and Database Structure using Firebase Auth and Firestore.",
  },
  {
    id: "cursor",
    name: "Cursor",
    cta: "Build with Cursor",
    url: "https://cursor.com",
    tagline: "Professional AI-assisted development.",
    bestFor: "Professional Developers",
    stack: "Your preferred stack",
    instructions:
      "Add this blueprint to your Cursor workspace as context. Use it to guide scaffolding, then implement each section as tasks.",
  },
  {
    id: "windsurf",
    name: "Windsurf",
    cta: "Build with Windsurf",
    url: "https://windsurf.com",
    tagline: "Modern AI coding workspace.",
    bestFor: "AI Coding Workspace",
    stack: "Your preferred stack",
    instructions:
      "Open this blueprint in Windsurf and let the AI workspace plan the build. Work through Required Screens and Database Structure in order.",
  },
];

export const getBuilder = (id) => BUILDERS.find((b) => b.id === id);
